/* Enganche libre en las calculadoras (docs/plans/calculadoras-pago-inicial-libre.md).
 *
 * El % se aplica sobre la base (precio + accesorios) y el resultado es el monto
 * que se manda tal cual a la calculadora. El usuario solo escribe el monto; el %
 * se deriva. Mínimo y máximo vienen de getStaticData (enganche_minimo/maximo). */

export const ENGANCHE_MIN_PCT_DEFAULT = 10;
export const ENGANCHE_MAX_PCT_DEFAULT = 40;

const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

/* Límites en pesos. El mínimo sube al peso (nunca queda debajo del %) y el
 * máximo baja al peso y nunca pasa de la base. */
export function limitesPagoInicial({ base, minPct = ENGANCHE_MIN_PCT_DEFAULT, maxPct = ENGANCHE_MAX_PCT_DEFAULT }) {
    const b = num(base);
    if (b <= 0) return { min: 0, max: 0 };
    const min = Math.ceil((b * num(minPct)) / 100);
    const max = Math.max(min, Math.min(Math.floor((b * num(maxPct)) / 100), Math.floor(b)));
    return { min, max };
}

/* Redondea al peso y limita al rango. `ajuste` dice si se movió al mínimo o al máximo. */
export function ajustarPagoInicial({ monto, base, minPct, maxPct }) {
    const { min, max } = limitesPagoInicial({ base, minPct, maxPct });
    const redondeado = Math.round(num(monto));
    if (max <= 0) return { monto: redondeado, ajuste: null, min, max };
    if (redondeado < min) return { monto: min, ajuste: 'min', min, max };
    if (redondeado > max) return { monto: max, ajuste: 'max', min, max };
    return { monto: redondeado, ajuste: null, min, max };
}

/* % para mostrar: entero si es exacto, si no con 1 decimal. */
export function pctPagoInicial(monto, base) {
    const b = num(base);
    if (b <= 0) return 0;
    const pct = Math.round((num(monto) / b) * 1000) / 10;
    return Number.isInteger(pct) ? pct : Number(pct.toFixed(1));
}

/* Monto desde un % de la barra, sin caer debajo del mínimo por el redondeo. */
export function montoDesdePct({ pct, base, minPct, maxPct }) {
    return ajustarPagoInicial({ monto: (num(base) * num(pct)) / 100, base, minPct, maxPct }).monto;
}

/* Acepta "$40,000.50", "40000", "40 000". Devuelve null si no hay número. */
export function parseMonto(texto) {
    if (texto === null || texto === undefined) return null;
    const limpio = String(texto).replace(/[^\d.]/g, '');
    if (!limpio || !/\d/.test(limpio)) return null;
    const n = parseFloat(limpio);
    return Number.isFinite(n) ? n : null;
}

/* Mensaje corto cuando el monto se ajustó. */
export function mensajeAjuste(ajuste, { min, max }, { minPct, maxPct }, formatMoney) {
    if (ajuste === 'min') return `El mínimo es ${minPct}% (${formatMoney(min)}). Lo ajustamos.`;
    if (ajuste === 'max') return `El máximo es ${maxPct}% (${formatMoney(max)}). Lo ajustamos.`;
    return null;
}
